import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {PaymentCardDto} from "../../../../models/payment-card-dto";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-canceled-payment-method-save',
  templateUrl: './canceled-payment-method-save.component.html',
  styleUrls: ['./canceled-payment-method-save.component.scss'],
  standalone: false
})
export class CanceledPaymentMethodSaveComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Canceled Payment Method Update'}
  ];

  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageErrorMessages: any[] = [];
  showPageErrorMessages: boolean = false;
  pageSuccessMessages: any[] = [];
  showSuccessMessages: boolean = false;
  showPageSuccessMessages: boolean = false;

  pageName = 'Canceled Payment Method Update';

  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Canceled Payment Method Update");
  }

  showSuccessMessagesToUser(delayMs: number = 10000): void {
    this.showSuccessMessages = true;
    const counterFn = () => {
      this.showSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageSuccessMessagesToUser(delayMs: number = 10000): void {
    this.showPageSuccessMessages = true;
    const counterFn = () => {
      this.showPageSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showPageErrorMessagesToUser(delayMs: number = 10000): void {
    this.showPageErrorMessages = true;
    const counterFn = () => {
      this.showPageErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    setTimeout(counterFn, 10000);
  }

  onGoToDashboard(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
